export default __webpack_public_path__ + "eda0a98.png";